import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    dataList: [],
    totalRows: 0,
  },
  getters: {
    dataList: state => state.dataList,
    totalRows: state => state.totalRows,
  },
  mutations: {
    SET_DATA: (state, { total, records }) => {
      state.totalRows = total
      state.dataList = records
    },
  },
  actions: {
    async readData({ commit }, params) {
      try {
        const response = await axios.get('uni/payments', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_DATA', { total, records })
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async readAllData({ commit }, params) {
      try {
        const response = await axios.get('uni/payments', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          return data.data.records
        }
      } catch (e) {
        handleCatch(e)
      }
      return []
    },
    async updateStatusReturnMoney({ commit }, params) {
      try {
        const response = await axios.put(`uni/receipt/returnMoney/${params}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
